import React from 'react';

export function AdminCard({
  title,
  description,
  actions,
  children,
  className = '',
  bodyClassName = ''
}) {
  return (
    <section className={`admin-card ${className}`}>
      {(title || description || actions) && (
        <div className="admin-card-header">
          <div>
            {title && <h3 className="admin-card-title">{title}</h3>}
            {description && <p className="admin-card-desc">{description}</p>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={`admin-card-body ${bodyClassName}`}>{children}</div>
    </section>
  );
}

export default AdminCard;
